import React from 'react';
import { useLocale } from '@/hooks/useLocale';
import { ILocales } from '@/interfaces/locales.interfaces';
import Image from 'next/image';
import { SiteSelectorButton } from './LocaleSelectorImage';

export type LocaleSelectorContentProps = {
    children: React.ReactNode;
    onChange?: (locale: ILocales) => void;
};
export const LocaleSelectorContent = ({ children, onChange }: LocaleSelectorContentProps) => {
    const [, setLocale] = useLocale();
    return (
        <>
            <div className="flex items-start justify-between">
                <div>
                    <div className="text-lg font-semibold">Pick a destination!</div>
                    <div className="mt-1 text-sm text-primary/70">{children}</div>
                </div>
            </div>
            <div className="mt-5 flex gap-3">
                <SiteSelectorButton
                    title="Australia"
                    onClick={() => {
                        setLocale(ILocales.en_AU)
                            .then()
                            .catch()
                            .finally(() => onChange?.(ILocales.en_AU));
                    }}
                >
                    <Image src="/images/Australia-Popup-Image.jpg" alt="Australia" fill sizes="(max-width: 640px) 50vw, 200px" className="object-cover" />
                </SiteSelectorButton>
                <SiteSelectorButton
                    title="New Zealand"
                    onClick={() => {
                        setLocale(ILocales.en_NZ)
                            .then()
                            .catch()
                            .finally(() => onChange?.(ILocales.en_NZ));
                    }}
                >
                    <Image src="/images/New-Zealand-Popup-Image.jpg" alt="New Zealand" fill sizes="(max-width: 640px) 50vw, 200px" className="object-cover" />
                </SiteSelectorButton>
            </div>
        </>
    );
};
